<template>
  <div class="about">
    <v-container>
      <v-row>
        <v-col cols="12">
          <h3 class="text-center display-1 py-6">About Lowkey Hubadera</h3>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "home",
  components: {}
};
</script>
